import styled, { css } from 'styled-components';
import { Modal } from './Modal';
import { smallScreenSize } from '../../hooks';

export const ModalBase = styled(Modal)`
  & > * {
    display: grid;
    grid-template-rows: 100%;
  }
`;

export const ModalWrapper = styled.div`
  display: grid;
  grid-template-rows: max-content 1fr;
  grid-auto-rows: max-content;
  grid-row-gap: 2.8rem;

  height: max-content;
`;

export const ModalBodyInputs = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: var(--spacing-6);
  grid-auto-rows: max-content;
  grid-row-gap: 2.8rem;

  @media (max-width: ${smallScreenSize}px) {
    grid-row-gap: var(--spacing-6);
  }
`;

interface ModalBodyCustomColumnsProps {
  columns: string;
  withInputHeight?: boolean;
  isSticky?: boolean;
}

export const ModalBodyCustomColumns = styled(ModalBodyInputs)<ModalBodyCustomColumnsProps>`
  grid-template-columns: ${(props) => props.columns};

  &:empty {
    display: none;
  }

  ${(props) =>
    props.isSticky &&
    css`
      position: sticky;
      top: -2.8rem;

      padding: 2.8rem 0 2.8rem;
      margin: -2.8rem 0 -2.8rem;
      background-color: var(--white);
      z-index: 1000;
    `}

  ${(props) =>
    props.withInputHeight &&
    css`
      align-items: center;
      min-height: 4rem;
      grid-template-rows: 4rem;
    `}


  & .row-button-square {
    margin-top: var(--spacing-6);
  }
`;

export const ModalBodyAutoColumns = styled.div<{ autoColumn: string; gridColumn?: string }>`
  display: grid;
  grid-auto-columns: ${(props) => props.autoColumn};
  grid-auto-flow: column;
  grid-column: ${(props) => props.gridColumn || '1 / 2'};
  grid-column-gap: var(--spacing-6);

  &:empty {
    display: none;
  }
`;

interface ModalFooterButtonsProps {
  columns?: string;
}

export const ModalFooterButtons = styled.div<ModalFooterButtonsProps>`
  display: grid;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  grid-column-gap: var(--spacing-3);
  justify-content: end;

  ${(props) =>
    props.columns &&
    css`
      grid-template-columns: ${props.columns};
    `}
`;
